import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrganizationSettings } from 'src/app/key-cabinet/models/organization/organization-settings.model';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { filter, Observable } from 'rxjs';
import {
  OrganizationResult,
  OrganizationStartupSettingsResult,
} from 'src/app/shared/models/agency-mgmt/manager.service.model';
import { CacheService } from '../cache.service';
@Injectable({
  providedIn: 'root',
})
export class OrganizationService extends BaseService {
  private readonly urlPrefix = `${environment.agencyMgmt.urlPrefix}/organization`;

  constructor(http: HttpClient, private cacheService: CacheService) {
    super(http);
  }

  public getOrganizationSettings() {
    return this.get<OrganizationSettings>(`${this.urlPrefix}/settings`);
  }
  getList(): Observable<OrganizationResult[]> {
    return this.cacheService.get(
      `${this.constructor.name}_${this.getList.name}`,
      `noversion`,
      this.get<OrganizationResult[]>(`${this.urlPrefix}/list`),
      []
    );
  }

  getStartupSettings(): Observable<OrganizationStartupSettingsResult> {
    return this.cacheService
      .get(
        `${this.constructor.name}_${this.getStartupSettings.name}`,
        `noversion`,
        this.get<OrganizationStartupSettingsResult>(
          `${this.urlPrefix}/settings/startup`
        ),
        []
      );
  }

}

